import { normalizeLocale } from '@evi/shared';
import { SupportMessage } from '@/components/ui/SupportMessage';
import { fillPayoutCopy, payoutSetupCopy, splitSupportPhrase } from '@/lib/payoutSetupCopy';

/**
 * SupportMessage for translated payout copy. English renders through SupportMessage exactly as before.
 * Another language links its own support phrase (payoutSetupCopy supportPhrase) to the same mailbox, and
 * the rest still goes through SupportMessage, so an English server message keeps its link too.
 */
export function PayoutSupportMessage({ text, locale }: { text: string; locale: string }) {
  if (normalizeLocale(locale) === 'en') return <SupportMessage text={text} />;
  const link = payoutSetupCopy(locale).supportLink;
  return <>{splitSupportPhrase(text, locale).map((part, i) => part.support
    ? <a key={i} href="mailto:partners@evinitiative.com">{fillPayoutCopy(link, { phrase: part.text })}</a>
    : <SupportMessage key={i} text={part.text} />)}</>;
}
